import { FC } from 'react';
import {coldarkDark} from "react-syntax-highlighter/dist/esm/styles/prism";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import styled, {createGlobalStyle} from "styled-components";

const CodeViewerContainer = styled.div`
    width: 100vw;
    overflow: scroll;
    overflow-y: auto;
    overflow-x: hidden;
    background: rgb(17, 27, 39);

    ::-webkit-scrollbar {
        width: 8px; 
        height: 8px; 
    }

    ::-webkit-scrollbar-track {
        background: rgb(17, 27, 39); 
        border-radius: 10px;
    }

    ::-webkit-scrollbar-thumb {
        background-color: #757575; 
        border-radius: 10px;
        border: 2px solid #2e2e2e;
    }


    pre {
        overflow: hidden!important;
        margin: 0 !important;
    }
`

const HideScroll = createGlobalStyle`
    body {
      overflow-y: hidden!important;
    }
`


export const CodeViewerModal: FC<{
    text: string
}> = ({ text }) => {

    return <CodeViewerContainer>
        <HideScroll/>
        <SyntaxHighlighter showLineNumbers language="javascript" style={{...coldarkDark}} customStyle={{
        fontSize: '15px',
        lineHeight: '20px',
    }}>
        {text}
    </SyntaxHighlighter></CodeViewerContainer>

}import { FC } from 'react';
import {coldarkDark} from "react-syntax-highlighter/dist/esm/styles/prism";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import styled, {createGlobalStyle} from "styled-components";

const CodeViewerContainer = styled.div`
    width: 100vw;
    overflow: scroll;
    overflow-y: auto;
    overflow-x: hidden;
    background: rgb(17, 27, 39);

    ::-webkit-scrollbar {
        width: 8px; 
        height: 8px; 
    }

    ::-webkit-scrollbar-track {
        background: rgb(17, 27, 39); 
        border-radius: 10px;
    }

    ::-webkit-scrollbar-thumb {
        background-color: #757575; 
        border-radius: 10px;
        border: 2px solid #2e2e2e;
    }


    pre {
        overflow: hidden!important;
        margin: 0 !important;
    }
`

const HideScroll = createGlobalStyle`
    body {
      overflow-y: hidden!important;
    }
`


export const CodeViewerModal: FC<{
    text: string
}> = ({ text }) => {

    return <CodeViewerContainer>
        <HideScroll/>
        <SyntaxHighlighter showLineNumbers language="javascript" style={{...coldarkDark}} customStyle={{
        fontSize: '15px',
        lineHeight: '20px',
    }}>
        {text}
    </SyntaxHighlighter></CodeViewerContainer>

}